var exports = {
  "L": "issueDependenciesList__V7A14B",
  "S": "issueDependencyItem__eriRlm",
};

module.exports = exports;
